import { handleActions } from 'redux-actions';
import ReportPreviewPage from 'models/data/report-preview-page-model';

import {
  setSelectedElementDetails,
  clearReportPreviewPageData,
  setReOrderedColumnOptions,
  resetReOrderedColumnOptions,
  setReportPreviewPageDisplayOptions,
  clearSelectedElementsSectionId,
} from 'store/actions/report-preview-page-actions';

export default handleActions(
  {
    [setSelectedElementDetails]: (reportPreviewPage, { payload }) => {
      return reportPreviewPage.setSelectedElementDetails(payload);
    },
    [clearReportPreviewPageData]: (reportPreviewPage) => {
      return reportPreviewPage.clearReportPreviewPageData();
    },
    [setReOrderedColumnOptions]: (reportPreviewPage, { payload }) => {
      return reportPreviewPage.setReorderedColumnList(payload);
    },
    [setReportPreviewPageDisplayOptions]: (reportPreviePage, { payload }) => {
      return reportPreviePage.setReportPreviewPageDisplayOptions(payload);
    },
    [clearSelectedElementsSectionId]: (reportPreviewPage) => {
      return reportPreviewPage.clearSelectedElementsSectionId();
    },
    [resetReOrderedColumnOptions]: () => {
      return new ReportPreviewPage();
    },
  },
  new ReportPreviewPage(),
);
